import { render } from "./GridPurchaseInvoiceDetail.vue?vue&type=template&id=3bd44036&scoped=true"
import script from "./GridPurchaseInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./GridPurchaseInvoiceDetail.vue?vue&type=script&lang=js"

import "./GridPurchaseInvoiceDetail.vue?vue&type=style&index=0&id=3bd44036&scoped=true&lang=css"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd44036"]])

export default __exports__